import { useEffect, useState, useRef } from 'react';
import Header from '../Header/Header';
import MapPicker from '../MapPicker/MapPicker';
import Toast from '../Toast/Toast';
import YSNameInput from './YSNameInput';
import YSForm from './YSForm';
import YSResult from './YSResult';
import { getParticipants, saveParticipant, deleteParticipant } from '../../api/ysApi';
import { getAddress } from '../../api/addressApi';
import { YSContainer } from './YS.styles';

const YS = () => {
    const [step, setStep] = useState(1);
    const [name, setName] = useState('');
    const [participants, setParticipants] = useState([]);
    const [toastMsg, setToastMsg] = useState(null);

    // 지도 관련
    const [showMap, setShowMap] = useState(false);
    const [mapLat, setMapLat] = useState(37.5665);
    const [mapLon, setMapLon] = useState(126.978);
    const mapTarget = useRef('departure'); // 'departure' or 'destination'

    // 폼 데이터
    const [departure, setDeparture] = useState(null);
    const [destination, setDestination] = useState(null);
    const [savedForm, setSavedForm] = useState(null);

    useEffect(() => {
        const saved = localStorage.getItem('ys_name');
        if (saved) {
            setName(saved);
            setStep(2);
            loadExistingData(saved);
        }
    }, []);

    const loadExistingData = async (userName) => {
        try {
            const data = await getParticipants();
            setParticipants(data.participants || []);
            const mine = (data.participants || []).find(p => p.name === userName);
            if (mine) {
                setDeparture(mine.departure);
                setDestination(mine.destination);
                setSavedForm(mine);
            }
        } catch (e) {
            // 서버 미연결 시 무시
        }
    };

    const handleNameSubmit = (n) => {
        localStorage.setItem('ys_name', n);
        setName(n);
        setStep(2);
        loadExistingData(n);
    };

    const handleOpenMap = (target) => {
        mapTarget.current = target;
        if (target === 'departure' && departure) {
            setMapLat(departure.lat);
            setMapLon(departure.lon);
        } else if (target === 'destination' && destination) {
            setMapLat(destination.lat);
            setMapLon(destination.lon);
        }
        setShowMap(true);
    };

    const handleMapSelect = (lat, lon) => {
        setShowMap(false);
        setToastMsg('주소 조회 중...');

        getAddress(lon, lat, (addr) => {
            setToastMsg(null);
            const label = addr && addr.address_name
                ? addr.address_name
                : `${lat.toFixed(4)}, ${lon.toFixed(4)}`;
            const loc = { label, lat, lon };
            if (mapTarget.current === 'departure') {
                setDeparture(loc);
            } else {
                setDestination(loc);
            }
        });
    };

    const handleSave = async (data) => {
        setToastMsg('저장 중...');
        try {
            const res = await saveParticipant(data);
            setParticipants(res.participants);
            setToastMsg(null);
            alert('저장되었습니다.');
        } catch (e) {
            setToastMsg(null);
            alert('서버 연결에 실패했습니다.');
        }
    };

    const handleDelete = async (delName) => {
        if (!window.confirm(delName + '의 정보를 삭제할까요?')) return;
        try {
            const res = await deleteParticipant(delName);
            setParticipants(res.participants);
        } catch (e) {
            alert('서버 연결에 실패했습니다.');
        }
    };

    const handleShowList = async () => {
        setToastMsg('데이터 조회 중...');
        try {
            const data = await getParticipants();
            setParticipants(data.participants || []);
            setToastMsg(null);
            setStep(3);
        } catch (e) {
            setToastMsg(null);
            alert('서버 연결에 실패했습니다.');
        }
    };

    return (
        <YSContainer>
            {step === 1 && <YSNameInput onSubmit={handleNameSubmit} />}

            {step >= 2 && <Header />}

            {step === 2 && <>
                <YSForm
                    name={name}
                    departure={departure}
                    destination={destination}
                    savedForm={savedForm}
                    onSave={handleSave}
                    onShowList={handleShowList}
                    onOpenMap={handleOpenMap}
                />
            </>}

            {step === 3 &&
                <YSResult
                    participants={participants}
                    myName={name}
                    onDelete={handleDelete}
                    onBack={() => setStep(2)}
                />
            }

            <MapPicker
                show={showMap}
                lat={mapLat}
                lon={mapLon}
                onSelect={handleMapSelect}
                onClose={() => setShowMap(false)}
            />
            <Toast message={toastMsg} />
        </YSContainer>
    );
};

export default YS;
